/**
 * @fileoverview gRPC-Web generated client stub for witbooking.backoffice.orchestrator.globalactions.v1
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!



const grpc = {};
grpc.web = require('grpc-web');


var validate_validate_pb = require('../../../../../validate/validate_pb.js')

var witbooking_backoffice_orchestrator_common_v1_orchestration_criteria_pb = require('../../../../../witbooking/backoffice/orchestrator/common/v1/orchestration_criteria_pb.js')
const proto = {};
proto.witbooking = {};
proto.witbooking.backoffice = {};
proto.witbooking.backoffice.orchestrator = {};
proto.witbooking.backoffice.orchestrator.globalactions = {};
proto.witbooking.backoffice.orchestrator.globalactions.v1 = require('./global_actions_api_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.witbooking.backoffice.orchestrator.globalactions.v1.GlobalActionsAPIClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'binary';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.witbooking.backoffice.orchestrator.globalactions.v1.GlobalActionsAPIPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'binary';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.orchestrator.globalactions.v1.GetGlobalActionsConfigRequest,
 *   !proto.witbooking.backoffice.orchestrator.globalactions.v1.GetGlobalActionsConfigResponse>}
 */
const methodDescriptor_GlobalActionsAPI_GetGlobalActionsConfig = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.orchestrator.globalactions.v1.GlobalActionsAPI/GetGlobalActionsConfig',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.orchestrator.globalactions.v1.GetGlobalActionsConfigRequest,
  proto.witbooking.backoffice.orchestrator.globalactions.v1.GetGlobalActionsConfigResponse,
  /**
   * @param {!proto.witbooking.backoffice.orchestrator.globalactions.v1.GetGlobalActionsConfigRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.orchestrator.globalactions.v1.GetGlobalActionsConfigResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.orchestrator.globalactions.v1.GetGlobalActionsConfigRequest,
 *   !proto.witbooking.backoffice.orchestrator.globalactions.v1.GetGlobalActionsConfigResponse>}
 */
const methodInfo_GlobalActionsAPI_GetGlobalActionsConfig = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.orchestrator.globalactions.v1.GetGlobalActionsConfigResponse,
  /**
   * @param {!proto.witbooking.backoffice.orchestrator.globalactions.v1.GetGlobalActionsConfigRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.orchestrator.globalactions.v1.GetGlobalActionsConfigResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.orchestrator.globalactions.v1.GetGlobalActionsConfigRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.orchestrator.globalactions.v1.GetGlobalActionsConfigResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.orchestrator.globalactions.v1.GetGlobalActionsConfigResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.orchestrator.globalactions.v1.GlobalActionsAPIClient.prototype.getGlobalActionsConfig =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.orchestrator.globalactions.v1.GlobalActionsAPI/GetGlobalActionsConfig',
      request,
      metadata || {},
      methodDescriptor_GlobalActionsAPI_GetGlobalActionsConfig,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.orchestrator.globalactions.v1.GetGlobalActionsConfigRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.orchestrator.globalactions.v1.GetGlobalActionsConfigResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.orchestrator.globalactions.v1.GlobalActionsAPIPromiseClient.prototype.getGlobalActionsConfig =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.orchestrator.globalactions.v1.GlobalActionsAPI/GetGlobalActionsConfig',
      request,
      metadata || {},
      methodDescriptor_GlobalActionsAPI_GetGlobalActionsConfig);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.orchestrator.globalactions.v1.GetAllGlobalActionsConfigsRequest,
 *   !proto.witbooking.backoffice.orchestrator.globalactions.v1.GetAllGlobalActionsConfigsResponse>}
 */
const methodDescriptor_GlobalActionsAPI_GetAllGlobalActionsConfigs = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.orchestrator.globalactions.v1.GlobalActionsAPI/GetAllGlobalActionsConfigs',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.orchestrator.globalactions.v1.GetAllGlobalActionsConfigsRequest,
  proto.witbooking.backoffice.orchestrator.globalactions.v1.GetAllGlobalActionsConfigsResponse,
  /**
   * @param {!proto.witbooking.backoffice.orchestrator.globalactions.v1.GetAllGlobalActionsConfigsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.orchestrator.globalactions.v1.GetAllGlobalActionsConfigsResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.orchestrator.globalactions.v1.GetAllGlobalActionsConfigsRequest,
 *   !proto.witbooking.backoffice.orchestrator.globalactions.v1.GetAllGlobalActionsConfigsResponse>}
 */
const methodInfo_GlobalActionsAPI_GetAllGlobalActionsConfigs = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.orchestrator.globalactions.v1.GetAllGlobalActionsConfigsResponse,
  /**
   * @param {!proto.witbooking.backoffice.orchestrator.globalactions.v1.GetAllGlobalActionsConfigsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.orchestrator.globalactions.v1.GetAllGlobalActionsConfigsResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.orchestrator.globalactions.v1.GetAllGlobalActionsConfigsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.orchestrator.globalactions.v1.GetAllGlobalActionsConfigsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.orchestrator.globalactions.v1.GetAllGlobalActionsConfigsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.orchestrator.globalactions.v1.GlobalActionsAPIClient.prototype.getAllGlobalActionsConfigs =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.orchestrator.globalactions.v1.GlobalActionsAPI/GetAllGlobalActionsConfigs',
      request,
      metadata || {},
      methodDescriptor_GlobalActionsAPI_GetAllGlobalActionsConfigs,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.orchestrator.globalactions.v1.GetAllGlobalActionsConfigsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.orchestrator.globalactions.v1.GetAllGlobalActionsConfigsResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.orchestrator.globalactions.v1.GlobalActionsAPIPromiseClient.prototype.getAllGlobalActionsConfigs =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.orchestrator.globalactions.v1.GlobalActionsAPI/GetAllGlobalActionsConfigs',
      request,
      metadata || {},
      methodDescriptor_GlobalActionsAPI_GetAllGlobalActionsConfigs);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.orchestrator.globalactions.v1.CreateGlobalActionsConfigRequest,
 *   !proto.witbooking.backoffice.orchestrator.globalactions.v1.CreateGlobalActionsConfigResponse>}
 */
const methodDescriptor_GlobalActionsAPI_CreateGlobalActionsConfig = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.orchestrator.globalactions.v1.GlobalActionsAPI/CreateGlobalActionsConfig',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.orchestrator.globalactions.v1.CreateGlobalActionsConfigRequest,
  proto.witbooking.backoffice.orchestrator.globalactions.v1.CreateGlobalActionsConfigResponse,
  /**
   * @param {!proto.witbooking.backoffice.orchestrator.globalactions.v1.CreateGlobalActionsConfigRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.orchestrator.globalactions.v1.CreateGlobalActionsConfigResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.orchestrator.globalactions.v1.CreateGlobalActionsConfigRequest,
 *   !proto.witbooking.backoffice.orchestrator.globalactions.v1.CreateGlobalActionsConfigResponse>}
 */
const methodInfo_GlobalActionsAPI_CreateGlobalActionsConfig = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.orchestrator.globalactions.v1.CreateGlobalActionsConfigResponse,
  /**
   * @param {!proto.witbooking.backoffice.orchestrator.globalactions.v1.CreateGlobalActionsConfigRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.orchestrator.globalactions.v1.CreateGlobalActionsConfigResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.orchestrator.globalactions.v1.CreateGlobalActionsConfigRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.orchestrator.globalactions.v1.CreateGlobalActionsConfigResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.orchestrator.globalactions.v1.CreateGlobalActionsConfigResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.orchestrator.globalactions.v1.GlobalActionsAPIClient.prototype.createGlobalActionsConfig =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.orchestrator.globalactions.v1.GlobalActionsAPI/CreateGlobalActionsConfig',
      request,
      metadata || {},
      methodDescriptor_GlobalActionsAPI_CreateGlobalActionsConfig,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.orchestrator.globalactions.v1.CreateGlobalActionsConfigRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.orchestrator.globalactions.v1.CreateGlobalActionsConfigResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.orchestrator.globalactions.v1.GlobalActionsAPIPromiseClient.prototype.createGlobalActionsConfig =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.orchestrator.globalactions.v1.GlobalActionsAPI/CreateGlobalActionsConfig',
      request,
      metadata || {},
      methodDescriptor_GlobalActionsAPI_CreateGlobalActionsConfig);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.orchestrator.globalactions.v1.UpdateGlobalActionsConfigRequest,
 *   !proto.witbooking.backoffice.orchestrator.globalactions.v1.UpdateGlobalActionsConfigResponse>}
 */
const methodDescriptor_GlobalActionsAPI_UpdateGlobalActionsConfig = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.orchestrator.globalactions.v1.GlobalActionsAPI/UpdateGlobalActionsConfig',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.orchestrator.globalactions.v1.UpdateGlobalActionsConfigRequest,
  proto.witbooking.backoffice.orchestrator.globalactions.v1.UpdateGlobalActionsConfigResponse,
  /**
   * @param {!proto.witbooking.backoffice.orchestrator.globalactions.v1.UpdateGlobalActionsConfigRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.orchestrator.globalactions.v1.UpdateGlobalActionsConfigResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.orchestrator.globalactions.v1.UpdateGlobalActionsConfigRequest,
 *   !proto.witbooking.backoffice.orchestrator.globalactions.v1.UpdateGlobalActionsConfigResponse>}
 */
const methodInfo_GlobalActionsAPI_UpdateGlobalActionsConfig = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.orchestrator.globalactions.v1.UpdateGlobalActionsConfigResponse,
  /**
   * @param {!proto.witbooking.backoffice.orchestrator.globalactions.v1.UpdateGlobalActionsConfigRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.orchestrator.globalactions.v1.UpdateGlobalActionsConfigResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.orchestrator.globalactions.v1.UpdateGlobalActionsConfigRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.orchestrator.globalactions.v1.UpdateGlobalActionsConfigResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.orchestrator.globalactions.v1.UpdateGlobalActionsConfigResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.orchestrator.globalactions.v1.GlobalActionsAPIClient.prototype.updateGlobalActionsConfig =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.orchestrator.globalactions.v1.GlobalActionsAPI/UpdateGlobalActionsConfig',
      request,
      metadata || {},
      methodDescriptor_GlobalActionsAPI_UpdateGlobalActionsConfig,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.orchestrator.globalactions.v1.UpdateGlobalActionsConfigRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.orchestrator.globalactions.v1.UpdateGlobalActionsConfigResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.orchestrator.globalactions.v1.GlobalActionsAPIPromiseClient.prototype.updateGlobalActionsConfig =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.orchestrator.globalactions.v1.GlobalActionsAPI/UpdateGlobalActionsConfig',
      request,
      metadata || {},
      methodDescriptor_GlobalActionsAPI_UpdateGlobalActionsConfig);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.orchestrator.globalactions.v1.DeleteGlobalActionsConfigRequest,
 *   !proto.witbooking.backoffice.orchestrator.globalactions.v1.DeleteGlobalActionsConfigResponse>}
 */
const methodDescriptor_GlobalActionsAPI_DeleteGlobalActionsConfig = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.orchestrator.globalactions.v1.GlobalActionsAPI/DeleteGlobalActionsConfig',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.orchestrator.globalactions.v1.DeleteGlobalActionsConfigRequest,
  proto.witbooking.backoffice.orchestrator.globalactions.v1.DeleteGlobalActionsConfigResponse,
  /**
   * @param {!proto.witbooking.backoffice.orchestrator.globalactions.v1.DeleteGlobalActionsConfigRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.orchestrator.globalactions.v1.DeleteGlobalActionsConfigResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.orchestrator.globalactions.v1.DeleteGlobalActionsConfigRequest,
 *   !proto.witbooking.backoffice.orchestrator.globalactions.v1.DeleteGlobalActionsConfigResponse>}
 */
const methodInfo_GlobalActionsAPI_DeleteGlobalActionsConfig = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.orchestrator.globalactions.v1.DeleteGlobalActionsConfigResponse,
  /**
   * @param {!proto.witbooking.backoffice.orchestrator.globalactions.v1.DeleteGlobalActionsConfigRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.orchestrator.globalactions.v1.DeleteGlobalActionsConfigResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.orchestrator.globalactions.v1.DeleteGlobalActionsConfigRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.orchestrator.globalactions.v1.DeleteGlobalActionsConfigResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.orchestrator.globalactions.v1.DeleteGlobalActionsConfigResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.orchestrator.globalactions.v1.GlobalActionsAPIClient.prototype.deleteGlobalActionsConfig =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.orchestrator.globalactions.v1.GlobalActionsAPI/DeleteGlobalActionsConfig',
      request,
      metadata || {},
      methodDescriptor_GlobalActionsAPI_DeleteGlobalActionsConfig,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.orchestrator.globalactions.v1.DeleteGlobalActionsConfigRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.orchestrator.globalactions.v1.DeleteGlobalActionsConfigResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.orchestrator.globalactions.v1.GlobalActionsAPIPromiseClient.prototype.deleteGlobalActionsConfig =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.orchestrator.globalactions.v1.GlobalActionsAPI/DeleteGlobalActionsConfig',
      request,
      metadata || {},
      methodDescriptor_GlobalActionsAPI_DeleteGlobalActionsConfig);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.orchestrator.globalactions.v1.ReorderGlobalActionsConfigRequest,
 *   !proto.witbooking.backoffice.orchestrator.globalactions.v1.ReorderGlobalActionsConfigResponse>}
 */
const methodDescriptor_GlobalActionsAPI_ReorderGlobalActionsConfig = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.orchestrator.globalactions.v1.GlobalActionsAPI/ReorderGlobalActionsConfig',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.orchestrator.globalactions.v1.ReorderGlobalActionsConfigRequest,
  proto.witbooking.backoffice.orchestrator.globalactions.v1.ReorderGlobalActionsConfigResponse,
  /**
   * @param {!proto.witbooking.backoffice.orchestrator.globalactions.v1.ReorderGlobalActionsConfigRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.orchestrator.globalactions.v1.ReorderGlobalActionsConfigResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.orchestrator.globalactions.v1.ReorderGlobalActionsConfigRequest,
 *   !proto.witbooking.backoffice.orchestrator.globalactions.v1.ReorderGlobalActionsConfigResponse>}
 */
const methodInfo_GlobalActionsAPI_ReorderGlobalActionsConfig = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.orchestrator.globalactions.v1.ReorderGlobalActionsConfigResponse,
  /**
   * @param {!proto.witbooking.backoffice.orchestrator.globalactions.v1.ReorderGlobalActionsConfigRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.orchestrator.globalactions.v1.ReorderGlobalActionsConfigResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.orchestrator.globalactions.v1.ReorderGlobalActionsConfigRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.orchestrator.globalactions.v1.ReorderGlobalActionsConfigResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.orchestrator.globalactions.v1.ReorderGlobalActionsConfigResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.orchestrator.globalactions.v1.GlobalActionsAPIClient.prototype.reorderGlobalActionsConfig =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.orchestrator.globalactions.v1.GlobalActionsAPI/ReorderGlobalActionsConfig',
      request,
      metadata || {},
      methodDescriptor_GlobalActionsAPI_ReorderGlobalActionsConfig,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.orchestrator.globalactions.v1.ReorderGlobalActionsConfigRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.orchestrator.globalactions.v1.ReorderGlobalActionsConfigResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.orchestrator.globalactions.v1.GlobalActionsAPIPromiseClient.prototype.reorderGlobalActionsConfig =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.orchestrator.globalactions.v1.GlobalActionsAPI/ReorderGlobalActionsConfig',
      request,
      metadata || {},
      methodDescriptor_GlobalActionsAPI_ReorderGlobalActionsConfig);
};


module.exports = proto.witbooking.backoffice.orchestrator.globalactions.v1;

